import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DealResultEmpty } from './deal-result-empty';
import { DealResultView } from './deal-result-view';

import './deal-result.scss';

export const DealResult = memo(({ dealData = null }) => {
  return (
    <div className="deal-result" aria-live="polite">
      {dealData ? <DealResultView data={dealData} /> : <DealResultEmpty />}
    </div>
  );
});

DealResult.displayName = 'DealResult';

DealResult.propTypes = {
  dealData: PropTypes.shape({
    effectivePayment: PropTypes.string,
    effectivePaymentRatio: PropTypes.number,
    dueAtSigning: PropTypes.number,
    rating: PropTypes.number,
  }),
};
